import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import classNames from 'classnames'
import Icon from './Icon'
import styles from './ButtonWithIcon.icss'

class ButtonWithIcon extends React.Component {
	render() {
		const baseClasses = [...this.props.smallerButtons ? [styles.smallerButtons] : [], ...!this.props.iconName ? [styles.noIcon] : []]
		const { classes, title } = this.props
		return (
			<span className={classNames(styles.buttonSurround, this.props.className)}>
				<Button fullWidth={this.props.fullWidth} classes={{ root: classNames(styles.button, ...baseClasses, classes.root), label: classNames(styles.label, classes.label) }} onClick={this.props.onClick} title={title}>
					{this.props.iconName && <Icon name={this.props.iconName} />}
					{this.props.children && (
						<span className={classNames(styles.text, classes.children)}>
							{this.props.children}
						</span>
					)}
				</Button>
			</span>
		)
	}
}

ButtonWithIcon.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	title: PropTypes.string,
	classes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	smallerButtons: PropTypes.bool,
	fullWidth: PropTypes.bool,
	iconName: PropTypes.string,
	onClick: PropTypes.func
}

ButtonWithIcon.defaultProps = {
	children: undefined,
	className: undefined,
	title: undefined,
	classes: {},
	smallerButtons: false,
	fullWidth: true,
	iconName: undefined,
	onClick: () => {}
}

ButtonWithIcon.contextTypes = {
	translate: PropTypes.func
}

export default ButtonWithIcon



// WEBPACK FOOTER //
// ./src/components/ButtonWithIcon.jsx